import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";

// create an instance of axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  },
});

// response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error - ", error);
    return Promise.reject(error);
  }
);

// request interceptor to attach the authorization token to the headers
api.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

// HTTP service methods
const httpService = {
  get: (url, params, token) => api.get(url, { params }, { headers: {'authorizationtoken': `${token}`} }),
  post: (url, data, token) => api.post(url, data, { headers: {'authorizationtoken': `${token}`} }),
  put: (url, data, token) => api.put(url, data, { headers: {'authorizationtoken': `${token}`} }),
  delete: (url, data, token) => api.put(url, data, { headers: {'authorizationtoken': `${token}`} }),
};

export default httpService;
